import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Mimetype } from 'app/shared/mimetype';
import { IdexService } from 'app/idex.service';
import { UploadService } from '../upload.service';

declare let $: any;

@Component({
   selector: 'app-upload-files',
   templateUrl: './upload-files.component.html',
   styleUrls: ['./upload-files.component.css']
})
export class UploadFilesComponent {
   error: string;
   percentage = 0;
   object_file: any;
   count: any;
   percentage_all = 0;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService, private uploadService: UploadService) {}

   onMinimize() {
      $('.chat-content').slideToggle();
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item, true);
   }

   progressBar_percentage(percen: any, count: any) {
      if (document.body.contains(document.getElementById('p' + count))) {
         document.getElementById('p' + count).innerHTML = percen + '%';
         this.percentage = percen;
      }
   }

   allPercentage(percenall: any) {
      this.percentage_all = percenall;
   }

   onStop(file: any) {
      file.cancel = true;
      this.uploadService.cancelUpload(file.key).subscribe(
         data => {
            this.uploadService.totalfile--;
            this.uploadService.sum_count++;
            this.data.successUpload1(this.uploadService.sum_count);
         });
   }

}
